import { clsx } from 'clsx'
import { CircleButton } from 'component/Button/CircleButton'
import { Divider, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useClickOutside } from 'hook/useClickOutside'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { ProfileButton } from './ProfileButton'
import css from './ProfileHeader.module.scss'

const UNMOUNT = 200

export const ProfileHeader = observer(() => {
  const open = store.identities.open
  const [mounted, setMounted] = useState(open)
  const [closing, setClosing] = useState(false)
  const canAdd = store.identities.profiles.length < 5
  const className = clsx(css.header, opt.square && css.square, closing && css.closing)

  useEffect(() => {
    if (open) {
      setMounted(true)
      setClosing(false)
      return
    }
    if (!mounted) return
    setClosing(true)
    const timer = setTimeout(() => {
      setMounted(false)
      setClosing(false)
    }, UNMOUNT)
    return () => clearTimeout(timer)
  }, [open, mounted])

  const onClose = useLatestCallback(async () => {
    store.identities.open = false
  })

  const onRef = useClickOutside(() => {
    store.identities.open = false
  })

  if (!mounted) return null

  return <Vertical ref={onRef} className={className} pad={16} gap={16}>
    <Space gap={12} opposite>
      <Typo size={12} medium upper>
        {i18n('profile.Profiles')}
      </Typo>
      <CircleButton className={css.close} size={24} action={onClose}>
        <Icon size={16} name="close" />
      </CircleButton>
    </Space>
    <Space gap={12} wrap wide>
      {canAdd && <ProfileButton it={undefined} />}
      <Divider height={28} secondary />
      {store.identities.profiles.map(it => <ProfileButton key={it.key} it={it} />)}
    </Space>
  </Vertical>
})
